
import {message } from 'antd'
import axios from 'axios';
import { connectUSBPrinter, getUSBWriter } from './usb.printer';


const requestError = ({error, showErrorMessage }) => {
  if(error?.response?.status === 401 ) {
    
    window.location = `/?url=${encodeURIComponent(window.location.href)}`

  } else if(error?.response?.status === 402 ) {
    
    window.location = `/subscribe`

  }else{
    if(showErrorMessage !== false) {
      console.log(error)
      message.error(error?.response?.data?.res || error?.response?.data || error?.message || "Server application not available", 5);
    }
  }
}

const downloadImage = async (imageUrl, fileName = 'downloaded-image.jpg') => {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Optional: revoke object URL after download
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('Download failed:', error);
  }
};


export {requestError, downloadImage };

const downloadFile = async ({ url }) => {
  try {
      const response = await axios.get(url, {
          responseType: 'blob', // Ensures the response is a file (binary data)
          headers: { authorization: `Bearer ${localStorage.getItem("token")}` }
      });

      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      console.log(response.headers);
      let filename = 'download.xlsx'; // Default filename

      if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/);
          if (match && match[1]) {
              filename = match[1].trim().replace(/['"]/g, ''); // Remove surrounding quotes if any
          }
      }

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: response.headers['content-type'] });

      // Create a temporary anchor element for triggering download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;

      // Append the link to the document, click it, then remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke the Blob URL after download to free up resources
      URL.revokeObjectURL(link.href);
  } catch (error) {
      message.error('Failed to download the file. Please try again.');
      requestError({ error , showErrorMessage : false })
  }
};

const downloadPdfFile = async ({ url, fileName }) => {
  try {
      const response = await axios.get(url, {
          responseType: 'blob', // Ensures the response is a file (binary data)
          headers: { authorization: `Bearer ${localStorage.getItem("token")}` }
      });

      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let filename = fileName || 'download.pdf'; // Default filename

      if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/);
          if (match && match[1]) {
              filename = match[1].trim().replace(/['"]/g, ''); // Remove surrounding quotes if any
          }
      }

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: response.headers['content-type'] });

      // Create a temporary anchor element for triggering download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;

      // Append the link to the document, click it, then remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke the Blob URL after download to free up resources
      URL.revokeObjectURL(link.href);
  } catch (error) {
      message.error('Failed to download the file. Please try again.');
  }
};

const validatePhoneNumber = (phone) => {
  // Check if phone contains only digits
  const onlyDigitsRegex = /^\d+$/;

  // Reject if there is anything other than digits
  if (!onlyDigitsRegex.test(phone)) {
    return false;
  }

  // Validate correct prefix and length (exactly 10 digits)
  const phoneRegex = /^(078|077|071)\d{7}$/;

  return phoneRegex.test(phone);
};



const  isZimbabweanNumber = (phone) => {
  const normalized = phone.replace(/^\+?263|^0/, ''); // remove +263, 263, or 0 if present
  const zimbabweanRegex = /^(7[1378]\d{7})$/;
  return zimbabweanRegex.test(normalized);
};


const printReceipt = async (characteristic, data) => {
  const ESC = '\x1B';
  const GS = '\x1D';

  const {
    schoolAddress,
    schoolEmail,
    schoolPhone,
    studentName,
    studentNumber,
    receiptNumber,
    paymentDate,
    amount,
    paymentMethod,
    cashier,
    balance,
    receiptItems,
    currency,
    totalInvoicedAmount,
    isReprinting,
    studentClass,
    time
  } = data;

  // Build item lines
  let itemsText = "";
  if (receiptItems && receiptItems.length > 0) {
    receiptItems.forEach(item => {
      const itemName = item?.incomeType?.name || item?.name || "Item";
      const itemAmount = item?.amount || 0;
      itemsText += `${itemName.padEnd(18) || ''}  ${currency || ""} ${itemAmount}\n`;
    });
  }

  const lines = [

    ESC + "@",

    // ===== SCHOOL HEADER =====
    ESC + "a" + "\x01",
    ESC + "!" + "\x20",
    // `${schoolName}\n\n`,
    ESC + "!" + "\x00",
    `${schoolAddress}\n\n`,
    `${schoolEmail}\n\n`,
    `${schoolPhone}\n\n`,

    // ===== STUDENT =====
    ESC + "a" + "\x01",
    ESC + "!" + "\x10",
    `${studentName}\n`,
    ESC + "!" + "\x00",
    `Reg No.${studentNumber}\n`,
    ESC + "!" + "\x00",
    `Class: ${studentClass}\n`,
    ESC + "!" + "\x00",
    "\n",

    // ===== DETAILS =====
    ESC + "a" + "\x00",
    `Receipt ${isReprinting? '(Reprint)' : ''}:    #${receiptNumber}\n`,
    `Payment Date:         ${paymentDate}\n`,
    `Time:                  ${time}\n`,

    // ===== RECEIPT ITEMS =====
    `\nItems:\n`,
    itemsText,
    `\n`,

    `Amount Paid :      ${amount||''}\n${totalInvoicedAmount ? `Amount Invoiced:   ${totalInvoicedAmount}\n` : ''}`,
    `Payment Method:    ${paymentMethod}\n`,
    `Current Balance:   ${balance}\n`,
    `Cashier:    ${cashier}\n`,

    "\n\n",
    ESC + "a" + "\x01",
    "---- THANK YOU ----\n",
    "\n\n\n\n"
  ];

  const buffer = new TextEncoder().encode(lines.join(""));
  await characteristic.writeValue(buffer);
};

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const printViaBluetooth = async (receiptData) => {
  const SERVICE_UUID = '000018f0-0000-1000-8000-00805f9b34fb';
  const CHARACTERISTIC_UUID = '00002af1-0000-1000-8000-00805f9b34fb';

   try {

      const device = await navigator.bluetooth.requestDevice({
        filters: [{ namePrefix: 'Printer' }],
        optionalServices: [SERVICE_UUID]
      });

      const server = await device.gatt.connect();

      // ⚠️ REQUIRED on macOS
      await sleep(800);

      const service = await server.getPrimaryService(SERVICE_UUID);
      const characteristic = await service.getCharacteristic(CHARACTERISTIC_UUID);

      await printSchoolHeader(characteristic, receiptData?.schoolName)
      if(receiptData?.schoolLogo){
        await printLogo(
          characteristic,
          `${process.env.REACT_APP_API_URI}/s3?token=${localStorage.getItem("token")}&file=${receiptData?.schoolLogo}`
        );
      }

      await printReceipt(characteristic, receiptData);

      device.gatt.disconnect();
      return; // success

    } catch (error) {
      console.warn(error);
      throw error;
    }
};


export{downloadFile, downloadPdfFile, validatePhoneNumber, isZimbabweanNumber, printReceipt, printViaBluetooth };

const printSchoolHeader = async (characteristic, schoolName) => {
  const ESC = '\x1B';

  const text = [
    ESC + "@",
    ESC + "a" + "\x01",      // center
    ESC + "!" + "\x20",      // big font
    `${schoolName}\n`,
    ESC + "!" + "\x00"
  ].join("");

  await characteristic.writeValue(new TextEncoder().encode(text));
};

const  getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  const queryParams = {};
  for (const [key, value] of params.entries()) {
      queryParams[key] = value;
  }
  return queryParams;
}

export{getQueryParams}

/* ===============================
   CONSTANTS
================================ */
// const PRINTER_WIDTH = 384;
// const CHUNK_SIZE = 400;
// const WRITE_DELAY = 30;
const PRINTER_WIDTH = 384;
const CHUNK_SIZE = 240;   // was 400
const WRITE_DELAY = 5;

/* ===============================
   UTILS
================================ */
// const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const writeInChunks = async (characteristic, data, chunkSize = CHUNK_SIZE) => {
  for (let i = 0; i < data.length; i += chunkSize) {
    await characteristic.writeValue(data.slice(i, i + chunkSize));
    await sleep(WRITE_DELAY);
  }
};

const imageBitmapCache = new Map();

const isImageBlob = async (blob) => {
  const buf = await blob.slice(0, 8).arrayBuffer();
  const bytes = new Uint8Array(buf);

  // PNG: 89 50 4E 47 0D 0A 1A 0A
  const isPNG =
    bytes[0] === 0x89 &&
    bytes[1] === 0x50 &&
    bytes[2] === 0x4E &&
    bytes[3] === 0x47;

  // JPG: FF D8 FF
  const isJPG =
    bytes[0] === 0xff &&
    bytes[1] === 0xd8 &&
    bytes[2] === 0xff;

  return isPNG || isJPG;
};

const loadImageBitmap = async (url) => {
  if (imageBitmapCache.has(url)) return await imageBitmapCache.get(url);

  const p = (async () => {
    const res = await fetch(url, { cache: "force-cache" });
    const blob = await res.blob();

    const ok = await isImageBlob(blob);
    if (!ok) {
      const txt = await blob.text().catch(() => "");
      throw new Error(`Not image data. First bytes: ${txt.slice(0, 80)}`);
    }

    return await createImageBitmap(blob);
  })();

  imageBitmapCache.set(url, p);
  return await p;
};

/* ===============================
   PRINT LOGO
================================ */

const printLogo = async (characteristic, logoUrl) => {
  const bitmap = await loadImageBitmap(logoUrl);

  // --- FORCE PRINTER STATE RESET ---
  await characteristic.writeValue(new Uint8Array([0x1B, 0x40])); // ESC @
  await sleep(50);
  const escposData = imageToRaster(bitmap);

  // FIRST raster write must be small
  await writeInChunks(characteristic, escposData, 80);
  await sleep(100);
};


const imageToRaster = (bitmap, maxWidth = PRINTER_WIDTH) => {
  // --- SCALE IMAGE TO PRINTER WIDTH ---
  const scale = Math.min(1, maxWidth / bitmap.width);
  const imgWidth = Math.floor(bitmap.width * scale);
  const imgHeight = Math.floor(bitmap.height * scale);

  // --- FULL WIDTH CANVAS (FOR CENTERING) ---
  const canvas = document.createElement("canvas");
  canvas.width = maxWidth;
  canvas.height = imgHeight;

  const ctx = canvas.getContext("2d", { willReadFrequently: true });

  // white background (important for thermal)
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // center horizontally
  const xOffset = Math.floor((maxWidth - imgWidth) / 2);

  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(bitmap, xOffset, 0, imgWidth, imgHeight);

  const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

  const bytes = [];
  const width = canvas.width;
  const height = canvas.height;
  const bytesPerRow = Math.ceil(width / 8);

  // --- ESC/POS raster header (GS v 0) ---
  bytes.push(
    0x1d, 0x76, 0x30, 0x00,
    bytesPerRow & 0xff,
    (bytesPerRow >> 8) & 0xff,
    height & 0xff,
    (height >> 8) & 0xff
  );

  // --- IMAGE TO MONO RASTER ---
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < bytesPerRow * 8; x += 8) {
      let byte = 0;

      for (let bit = 0; bit < 8; bit++) {
        const xx = x + bit;
        if (xx >= width) continue;

        const i = (y * width + xx) * 4;
        const gray =
          0.299 * data[i] +
          0.587 * data[i + 1] +
          0.114 * data[i + 2];

        // thermal-friendly threshold
        if (gray < 180) byte |= (1 << (7 - bit));
      }

      bytes.push(byte);
    }
  }

  return new Uint8Array(bytes);
};


const printViaUSB = async (receiptData) => {
  try {
    const ok = await connectUSBPrinter();
    if (!ok) return; // user cancelled

    const characteristic = getUSBWriter(); // <-- looks like BLE characteristic
    if (!characteristic) throw new Error("USB writer not available");

    // optional: give device a tiny moment (some printers wake up)
    await sleep(50);

    await printSchoolHeader(characteristic, receiptData?.schoolName);

    if (receiptData?.schoolLogo) {
      await printLogo(
        characteristic,
        `${process.env.REACT_APP_API_URI}/s3?token=${localStorage.getItem("token")}&file=${receiptData?.schoolLogo}`
      );
    }

    await printReceipt(characteristic, receiptData);

    // optional: keep connected for faster next print (recommended)
    // await disconnectUSBPrinter();

  } catch (error) {
    console.warn(error);
    throw error;
  }
};

export { printViaUSB };

